export const GET_INTERNAL_REVIEWS = "getInternalReviews"

export default {
  [GET_INTERNAL_REVIEWS]: (state: InternalReviewsState): InternalReview[] => state.internalReviews
}
